// The /auth page marks the sign-in method this browser used last. The cookie
// holds only the method, never the address.
//
// Google and the email link leave the page before we know they worked, so the
// page writes a short-lived pending cookie and /auth/callback promotes it to
// the last-method cookie after a successful code exchange or verifyOtp. A
// password login knows right away and writes the last-method cookie itself.

import { parseCookieHeader } from "@supabase/ssr";

export const AUTH_METHODS = ["google", "email", "password"] as const;
export type AuthMethod = (typeof AUTH_METHODS)[number];

export const LAST_METHOD_COOKIE = "nimbia_last_method";
export const AUTH_PENDING_COOKIE = "nimbia_auth_pending";

const LAST_METHOD_MAX_AGE = 180 * 24 * 60 * 60;
const PENDING_MAX_AGE = 10 * 60;

export function parseAuthMethod(
  value: string | null | undefined,
): AuthMethod | null {
  return AUTH_METHODS.find((m) => m === value) ?? null;
}

// Reads the pending method from a raw Cookie header; null when absent or not
// one of the known methods.
export function pendingMethodFromCookieHeader(
  header: string | null,
): AuthMethod | null {
  const cookie = parseCookieHeader(header ?? "").find(
    (c) => c.name === AUTH_PENDING_COOKIE,
  );
  return parseAuthMethod(cookie?.value);
}

function cookieOptions(maxAge: number, secure: boolean) {
  return { maxAge, path: "/", sameSite: "lax" as const, secure };
}

export function lastMethodCookieOptions(secure: boolean) {
  return cookieOptions(LAST_METHOD_MAX_AGE, secure);
}

export function pendingCookieOptions(secure: boolean) {
  return cookieOptions(PENDING_MAX_AGE, secure);
}
